
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  todosReducer,
  addTodoReducer,
  editTodoReducer,
} from "./reducers/DataSlice";

import {
  projectsListReducer,
  currentProjectReducer,
  
} from "./reducers/ProjectsSlice";


import themeReducer from "./reducers/ThemeSlice";
import paramReducer from "./reducers/ParamSlice";
import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
  userListReducer,
  userDeleteReducer,

} from "./reducers/UserReducers";

const todoUserInfoFromStorage = localStorage.getItem("todoUserInfo")
  ? { loading:false,
    error:null,
    success:true,
    todoUserInfo: JSON.parse(localStorage.getItem("todoUserInfo")) }
  : { loading:false,
    error:null,
    success:false,
    todoUserInfo:{} };

const initialState = {
  userLogin: todoUserInfoFromStorage,
};

const logParamChanges =
  (store) => (next) => (action) => {
    const prev = store.getState().param;
    const result = next(action);
    const nextState = store.getState().param;

    if (prev !== nextState) {
      console.log('%c[param changed]',
        'background:#222;color:#0f0;padding:2px 4px',
        { action: action.type, payload: action.payload, prev, next: nextState }
      );
    }

    // Also trace *who* dispatched setCurrProjectId
    if (action.type === 'param/setCurrProjectId') {
      console.log('setCurrProjectId dispatched from:\n', new Error().stack);
    }

    return result;
  };

const createRootReducer = () =>
  combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,
    userList: userListReducer,
    userDelete: userDeleteReducer,
    todos: todosReducer,
    addTodo: addTodoReducer,
    editTodo: editTodoReducer,
    projectsList: projectsListReducer,
    currentProject: currentProjectReducer,
    theme: themeReducer,
    param: paramReducer,
  });

const createAppStore = () =>
  configureStore({
    middleware: (gdm) =>
      gdm({ immutableCheck: false, serializableCheck: false })
    // .concat(
    //     logParamChanges
    //   )
      ,
    // devTools: true,
   
    preloadedState: initialState,
    reducer: createRootReducer(),
  });

// reuse the same store across hot reloads
const store = window.__APP_STORE__ || createAppStore();
if (process.env.NODE_ENV !== 'production') {
   
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  window.__APP_STORE__ = store;
}

// Hot-replace reducers during HMR without recreating the store (preserve state)
if (process.env.NODE_ENV !== 'production' && module && module.hot) {
  module.hot.accept(
    [
      './reducers/DataSlice',
      './reducers/ProjectsSlice',
      './reducers/ThemeSlice',
      './reducers/ParamSlice',
      './reducers/UserReducers',
    ],
    () => {
      store.replaceReducer(createRootReducer());
    }
  );
}


// Export RootState and AppDispatch types
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
// export function setupStore(preloadedState) {
//   return configureStore({
//     middleware: (getDefaultMiddleware) =>
//       getDefaultMiddleware({
//         immutableCheck: false,
//         serializableCheck: false,
//       }),
//     preloadedState: preloadedState,
//     reducer: {
//       userLogin: userLoginReducer,
//       userRegister: userRegisterReducer,
//       userDetails: userDetailsReducer,
//       userUpdateProfile: userUpdateProfileReducer,
//       userList: userListReducer,
//       userDelete: userDeleteReducer,
//       todos: todosReducer,
//       addTodo: addTodoReducer,
//       editTodo: editTodoReducer,
//       projectsList: projectsListReducer,
//       currentProject: currentProjectReducer,
//       theme: themeReducer,
//       param: paramReducer,
//     },
//   })
// }
export default store;